import type { FC } from "react";
import { useMemo } from "react";
import { useStreamingDisplay } from "root/ChatPanel/hook/use-stream-effect.hook";
import { StreamState } from "types";
import { StreamingIndicator, TypewriterText } from "../StreamingIndicator";

export const AssistantMessageInProgress: FC<{
  streamingState: StreamState | null;
}> = ({ streamingState }) => {
  const { displayedReasoning } = useStreamingDisplay(
    streamingState?.reasoningText,
  );

  const displayText = useMemo(() => {
    if (!displayedReasoning) return "";

    return displayedReasoning
      .replace(/\\n/g, "\n")
      .replace(/\\t/g, "\t")
      .replace(/\\"/g, '"')
      .replace(/\\\\/g, "\\");
  }, [displayedReasoning]);

  const hasContent = displayText.length > 0;

  if (!hasContent) {
    return (
      <div className="p-3">
        <StreamingIndicator
          stage={streamingState?.stage}
          statusText={streamingState?.processingStatus}
        />
      </div>
    );
  }

  return (
    <div className="p-3 space-y-2">
      <TypewriterText
        text={displayText}
        isComplete={streamingState?.isComplete}
        showCursor={
          displayText.length === (streamingState?.reasoningText?.length ?? 0)
        }
      />
    </div>
  );
};
